const config = {
      API_URL: "https://api.skynyx.dev",
      // API_URL: "http://localhost:8000",
};

export default config;